import { render, staticRenderFns } from "./ClikAuto.vue?vue&type=template&id=64bbe4d2&scoped=true&"
import script from "./ClikAuto.vue?vue&type=script&lang=js&"
export * from "./ClikAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bbe4d2",
  null
  
)

export default component.exports